"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var SideMenuSubmenu = {
  styles: function styles(theme) {
    return {
      submenu: {
        "&:first-of-type $mainItem": {
          borderTop: 0
        },
        boxSizing: "content-box"
      },
      mainItem: {
        boxSizing: "content-box",
        fontFamily: 'Raleway, "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        fontSize: theme.typography.fontSize + 2,
        fontWeight: 500,
        letterSpacing: 0.44,
        lineHeight: 1.45,
        borderTop: {
          color: theme.colors.baseContrast010,
          width: 1,
          style: "solid"
        },
        paddingTop: theme.spacing.base * 2,
        paddingBottom: theme.spacing.base * 2,
        // eslint-disable-next-line @atg/css-rtl-support
        paddingLeft: theme.spacing.base * 2,
        "&:hover": {
          // opacity at 70% - https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4
          background: "".concat(theme.colors.baseContrast010, "B3")
        }
      },
      activeMainItem: {
        background: theme.colors.pageBackground,
        // eslint-disable-next-line @atg/css-rtl-support
        paddingLeft: theme.spacing.base * 2,
        borderLeft: {
          width: 0
        }
      },
      disabledMainItem: {
        color: theme.colors.baseContrast050,
        background: "transparent",
        "&:hover": {
          color: theme.colors.baseContrast050
        }
      },
      indicator: {
        fill: theme.colors.baseContrast085
      },
      subItem: {
        boxSizing: "content-box",
        height: theme.spacing.base * 6,
        fontFamily: 'Raleway, "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        fontSize: theme.typography.fontSize + 2,
        fontWeight: 400,
        letterSpacing: 0.44,
        background: theme.colors.pageBackground,
        "&:hover": {
          background: "".concat(theme.colors.baseContrast010, "B3"),
          color: theme.colors.baseContrast085
        }
      },
      activeSubmenuItem: {
        borderLeft: {
          width: 0
        },
        "&, & a": {
          background: theme.colors.pageBackground,
          color: theme.colors.baseContrast085,
          "&:hover, &:focus-visible": {
            backgroundColor: "".concat(theme.colors.baseContrast010, "B3"),
            color: theme.colors.baseContrast085
          }
        }
      },
      disabledSubmenuItem: {
        color: theme.colors.baseContrast040,
        "&:hover": {
          color: theme.colors.baseContrast040
        }
      }
    };
  }
};
var _default = exports.default = SideMenuSubmenu;